export default {
  list: [
    {
      value: 'FAIL',
      title: 'ERROR'
    },
    {
      value: 'ERROR',
      title: 'FAIL'
    },
    {
      value: 'SUCCESS',
      title: 'SUCCESS'
    }
  ],
  values: {
    FAIL: 'FAIL',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS'
  }
};
